<template>
<section id="home">
    <picture>
    <!-- Mobile first -->
    <source srcset="../../assets/img/splash-sm.webp" media="(max-width: 767px)">
    <!-- Tablets -->
    <source srcset="../../assets/img/splash-sm.webp" media="(max-width: 1024px)">
    <!-- Default / desktop -->
    <img
      src="../../assets/img/splash-lg.webp"
      alt="Hero image"
      class="hero-img"
    />
  </picture>
        <a class="sticker-btn mt-2" href="https://app.orderopia.com/ccf-fibreglass/order">SHOP NOW</a>
  
</section>
</template>

<style scoped>

section {
  position: relative;
}
.hero-img {
  height: 100dvh;
  width: 100vw;
  object-fit: cover;
  object-position: center;
}

.sticker-btn {
  position: absolute;
  font-weight: bold;
  font-size:18px;
  top: 70%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  color: white;
  border: none;
  text-align: center;
  background-color: transparent;
  background-image: url('@/assets/img/sticker-btn.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  width: 300px;
  height: 50px;
  -webkit-mask-image: url('@/assets/img/sticker-btn.webp');
  mask-image: url('@/assets/img/sticker-btn.webp');
  -webkit-mask-size: cover;
  mask-size: cover;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
}

.sticker-btn:hover {
  transform: translate(-50%, -50%) rotate(-2deg);
  transform-origin: center;
}


</style>
